import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./functionalAdminSlice";

export default function MessageForFunctionalAdmin() {
	const dispatch = useDispatch();
	const functionAdmin = useSelector((store) => store.functionAdmin);
	const { message, severity, messageOpen } = functionAdmin;
	const handleCloseSnackbar = () => {
		dispatch(setState("messageOpen", false));
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={messageOpen}
			autoHideDuration={5000}
			onClose={handleCloseSnackbar}
		>
			<Alert
				onClose={handleCloseSnackbar}
				severity={severity}
				sx={{ width: "100%" }}
			>
				{typeof message === "object" ? "Successfull" : message}
			</Alert>
		</Snackbar>
	);
}
